
import { Component } from 'vue-property-decorator';
import { mapState } from 'vuex';
import { mixins } from 'vue-class-component';
import IsExclusiveFilterMixin from './common/IsExclusiveFilterMixin';

@Component({
  computed: {
    ...mapState('mapForIsExclusiveFilter', ['isExclusive', 'isExclusiveCountOverall', 'isExclusiveCount']),
  },
})
export default class isExclusiveFilter extends mixins(IsExclusiveFilterMixin) {}
